import { createReducer } from 'reduxsauce'
import { INITIAL_STATE } from './initialState'
import { OperatorUserTypes } from './Actions'
import RequestState from 'Enums/RequestState'
import InfinityEnums from 'Enums/InfinityEnums'
import history from 'history/browser'

export const fetchOperatorUserListLoading = (state) => {
  return {
    ...state,
    fetchOperatorUserListRequestState: RequestState.LOADING,
  }
}
export const fetchOperatorUserListLoadingMore = (state) => {
  return {
    ...state,
    fetchOperatorUserListRequestState: RequestState.LOADING_MORE,
  }
}

export const fetchOperatorUserListSuccess = (
  state,
  { offset, operatorUsers, nextOffset },
) => {
  const slashArray = history.location.pathname.split('/')
  const alertPage = slashArray[1]

  if (alertPage === 'operatorAlerts') {
    let resultAlert = []
    for (let j = 0; j < operatorUsers.length; j++) {
      if (
        !state.operatorUsersAlertEmails.some(
          (operatorUser) => operatorUser.email === operatorUsers[j].email,
        )
      ) {
        resultAlert.push(operatorUsers[j])
      }
    }
    const emailsWithNames = Array.from(
      new Map(
        resultAlert
          .map((u) => [
            u?.email?.trim(),
            { email: u?.email?.trim(), name: (u?.name || '').trim() },
          ])
          .filter(([email]) => !!email),
      ).values(),
    )

    if (offset === 0) {
      return {
        ...state,
        fetchOperatorUserListRequestState: RequestState.SUCCEEDED,
        operatorUsersPagination: nextOffset,
        operatorUsersAlertEmails: [...emailsWithNames],
      }
    } else {
      return {
        ...state,
        fetchOperatorUserListRequestState: RequestState.SUCCEEDED,
        operatorUsersPagination: nextOffset,
        operatorUsersAlertEmails: [
          ...state.operatorUsersAlertEmails,
          ...emailsWithNames,
        ],
      }
    }
  } else {
    let result = []
    for (let j = 0; j < operatorUsers.length; j++) {
      if (
        !state.operatorUsers.some(
          (operatorUser) => operatorUser.id === operatorUsers[j].id,
        )
      ) {
        result.push(operatorUsers[j])
      }
    }
    if (offset === 0) {
      return {
        ...state,
        fetchOperatorUserListRequestState: RequestState.SUCCEEDED,
        operatorUsersPagination: nextOffset,
        operatorUsers: [...operatorUsers],
      }
    } else {
      return {
        ...state,
        fetchOperatorUserListRequestState: RequestState.SUCCEEDED,
        operatorUsersPagination: nextOffset,
        operatorUsers: [...state.operatorUsers, ...result],
      }
    }
  }
}

export const fetchOperatorUserListFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchOperatorUserListRequestState: requestState,
  }
}

export const updateOperatorUserLoading = (state) => {
  return {
    ...state,
    updateOperatorUserListRequestState: RequestState.LOADING,
    updateOperatorUserRequestState: RequestState.LOADING,
  }
}

export const updateOperatorUserSuccess = (
  state,
  { operatorUserId, operatorUser },
) => {
  const updatedOperatorUsers = state.operatorUsers.map((user) =>
    user.id === operatorUserId ? operatorUser : user,
  )

  const updatedClickedOperatorUser =
    state.clickedOperatorUser && state.clickedOperatorUser.id === operatorUserId
      ? operatorUser
      : state.clickedOperatorUser

  return {
    ...state,
    operatorUsers: updatedOperatorUsers,
    clickedOperatorUser: updatedClickedOperatorUser,
    updateOperatorUserListRequestState: RequestState.SUCCEEDED,
    updateOperatorUserRequestState: RequestState.SUCCEEDED,
  }
}
export const updateOperatorUserFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    updateOperatorUserListRequestState: requestState,
    updateOperatorUserRequestState: requestState,
  }
}

export const deleteOperatorUserLoading = (state) => {
  return {
    ...state,
    deleteOperatorUserRequestState: RequestState.LOADING,
  }
}

export const deleteOperatorUserSuccess = (state, { operatorUserId }) => {
  let newOperatorUsers = state.operatorUsers.filter(
    (operatorUser) => operatorUser.id !== operatorUserId,
  )

  return {
    ...state,
    operatorUsers: [...newOperatorUsers],
    deleteOperatorUserRequestState: RequestState.SUCCEEDED,
    clickedOperatorUser: {},
    operatorUsersCount: state.operatorUsersCount - 1,
  }
}

export const deleteOperatorUserFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    deleteOperatorUserRequestState: requestState,
  }
}

export const unblockOperatorUserLoading = (state) => {
  return {
    ...state,
    unblockOperatorUserRequestState: RequestState.LOADING,
  }
}

export const unblockOperatorUserSuccess = (
  state,
  { operatorUserId, operatorUser },
) => {
  const updatedOperatorUsers = state.operatorUsers.map((user) =>
    user.id === operatorUserId ? { ...user, ...operatorUser } : user,
  )

  const updatedClickedOperatorUser =
    state.clickedOperatorUser && state.clickedOperatorUser.id === operatorUserId
      ? { ...state.clickedOperatorUser, ...operatorUser }
      : state.clickedOperatorUser

  return {
    ...state,
    operatorUsers: updatedOperatorUsers,
    clickedOperatorUser: updatedClickedOperatorUser,
    unblockOperatorUserRequestState: RequestState.SUCCEEDED,
  }
}

export const unblockOperatorUserFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    unblockOperatorUserRequestState: requestState,
  }
}

export const fetchInviteOperatorUserListLoading = (state) => {
  return {
    ...state,
    fetchInviteOperatorUserListRequestState: RequestState.LOADING,
  }
}
export const fetchInviteOperatorUserListLoadingMore = (state) => {
  return {
    ...state,
    fetchInviteOperatorUserListRequestState: RequestState.LOADING_MORE,
  }
}

export const fetchInviteOperatorUserListSuccess = (
  state,
  { invitations, nextOffset, offset },
) => {
  const pendingInvitations = invitations.filter(
    (inv) =>
      inv.status === InfinityEnums.InvitationStatus.PENDING &&
      !state.inviteOperatorUsers.some((existing) => existing._id === inv._id),
  )

  if (offset === 0) {
    return {
      ...state,
      inviteOperatorUsers: pendingInvitations,
      fetchInviteOperatorUserListRequestState: RequestState.SUCCEEDED,
      inviteOperatorUsersPagination: nextOffset,
    }
  }

  return {
    ...state,
    inviteOperatorUsers: [...state.inviteOperatorUsers, ...pendingInvitations],
    fetchInviteOperatorUserListRequestState: RequestState.SUCCEEDED,
    inviteOperatorUsersPagination: nextOffset,
  }
}

export const fetchInviteOperatorUserListFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchInviteOperatorUserListRequestState: requestState,
  }
}

export const inviteOperatorUserLoading = (state) => {
  return {
    ...state,
    inviteOperatorUserRequestState: RequestState.LOADING,
  }
}

export const inviteOperatorUserSuccess = (state, { operatorUser }) => {
  return {
    ...state,
    inviteOperatorUsers: [operatorUser, ...state.inviteOperatorUsers],
    inviteOperatorUserRequestState: RequestState.SUCCEEDED,
    operatorUsersInvitationsCount: state.operatorUsersInvitationsCount + 1,
  }
}

export const inviteOperatorUserFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    inviteOperatorUserRequestState: requestState,
  }
}

export const deleteInviteOperatorUserLoading = (state) => {
  return {
    ...state,
    deleteInviteOperatorUserRequestState: RequestState.LOADING,
  }
}

export const deleteInviteOperatorUserSuccess = (
  state,
  { inviteOperatorUserId },
) => {
  let newInviteOperatorUsers = state.inviteOperatorUsers.filter(
    (inviteOperatorUser) => inviteOperatorUser._id !== inviteOperatorUserId,
  )
  return {
    ...state,
    inviteOperatorUsers: [...newInviteOperatorUsers],
    deleteInviteOperatorUserRequestState: RequestState.SUCCEEDED,
    operatorUsersInvitationsCount: state.operatorUsersInvitationsCount - 1,
  }
}

export const deleteInviteOperatorUserFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    deleteInviteOperatorUserRequestState: requestState,
  }
}

export const sendOperatorUserEmailLoading = (state) => {
  return {
    ...state,
    sendOperatorUserEmailRequestState: RequestState.LOADING,
  }
}

export const sendOperatorUserEmailSuccess = (state) => {
  return {
    ...state,
    sendOperatorUserEmailRequestState: RequestState.SUCCEEDED,
  }
}

export const sendOperatorUserEmailFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    sendOperatorUserEmailRequestState: requestState,
  }
}

export const fetchInviteOperatorUserLoading = (state) => {
  return {
    ...state,
    fetchInviteOperatorUserRequestState: RequestState.LOADING,
  }
}

export const fetchInviteOperatorUserSuccess = (
  state,
  { inviteOperatorUser },
) => {
  return {
    ...state,
    inviteOperatorUser: { ...inviteOperatorUser },
    fetchInviteOperatorUserRequestState: RequestState.SUCCEEDED,
  }
}

export const fetchInviteOperatorUserFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchInviteOperatorUserRequestState: requestState,
  }
}

export const setInviteOperatorUserStatus = (state, { status }) => {
  return {
    ...state,
    inviteOperatorUserStatus: status,
  }
}

export const createOperatorUserLoading = (state) => {
  return {
    ...state,
    createOperatorUserRequestState: RequestState.LOADING,
  }
}

export const createOperatorUserSuccess = (state) => {
  return {
    ...state,
    createOperatorUserRequestState: RequestState.SUCCEEDED,
  }
}

export const createOperatorUserFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    createOperatorUserRequestState: requestState,
  }
}

export const fetchTariffsListLoading = (state) => {
  return {
    ...state,
    fetchTariffListRequestState: RequestState.LOADING,
  }
}

export const fetchTariffsListSuccess = (state, { tariffs }) => {
  return {
    ...state,
    tariffsList: [...tariffs],
    fetchTariffListRequestState: RequestState.SUCCEEDED,
  }
}

export const fetchTariffsListFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchTariffListRequestState: requestState,
  }
}

export const fetchPrivacyScheduleLoading = (state) => {
  return {
    ...state,
    fetchPrivacyScheduleRequestState: RequestState.LOADING,
  }
}

export const fetchPrivacyScheduleSuccess = (state, { PrivacySchedule }) => {
  return {
    ...state,
    privacySchedule: [...PrivacySchedule],
    fetchPrivacyScheduleRequestState: RequestState.SUCCEEDED,
  }
}

export const fetchPrivacyScheduleFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchPrivacyScheduleRequestState: requestState,
  }
}

export const fetchAccessGroupsListLoading = (state) => {
  return {
    ...state,
    fetchAccessGroupsListRequestState: RequestState.LOADING,
  }
}

export const fetchAccessGroupsListSuccess = (state, { accessGroups }) => {
  return {
    ...state,
    accessGroupsList: [...accessGroups],
    fetchAccessGroupsListRequestState: RequestState.SUCCEEDED,
  }
}

export const fetchAccessGroupsListFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchAccessGroupsListRequestState: requestState,
  }
}

export const fetchOperatorUsersCountLoading = (state) => {
  return {
    ...state,
    fetchOperatorUsersCountRequestState: RequestState.LOADING,
  }
}
export const fetchOperatorUsersCountSuccess = (state, { count }) => {
  return {
    ...state,
    fetchOperatorUsersCountRequestState: RequestState.SUCCEEDED,
    operatorUsersCount: count,
  }
}

export const fetchOperatorUsersCountFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchOperatorUsersCountRequestState: requestState,
  }
}

export const fetchOperatorUsersInvitationsCountLoading = (state) => {
  return {
    ...state,
    fetchOperatorUsersInvitationsCountRequestState: RequestState.LOADING,
  }
}
export const fetchOperatorUsersInvitationsCountSuccess = (state, { count }) => {
  return {
    ...state,
    fetchOperatorUsersInvitationsCountRequestState: RequestState.SUCCEEDED,
    operatorUsersInvitationsCount: count,
  }
}

export const fetchOperatorUsersInvitationsCountFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchOperatorUsersInvitationsCountRequestState: requestState,
  }
}
export const clearOperatorUsers = (state) => {
  return {
    ...state,
    operatorUsers: [],
    operatorUsersPagination: 0,
    fetchOperatorUserListRequestState: RequestState.UNINITIALIZED,
    operatorUsersAlertEmails: [],
  }
}
export const clearInvitations = (state) => {
  return {
    ...state,
    inviteOperatorUsers: [],
    inviteOperatorUsersPagination: 0,
    fetchInviteOperatorUserListRequestState: RequestState.UNINITIALIZED,
  }
}

export const changePasswordOrNameLoading = (state) => {
  return {
    ...state,
    changePasswordOrNameRequestState: RequestState.LOADING,
  }
}
export const changePasswordOrNameSuccess = (state) => {
  return {
    ...state,
    changePasswordOrNameRequestState: RequestState.SUCCEEDED,
  }
}

export const changePasswordOrNameFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    changePasswordOrNameRequestState: requestState,
  }
}
export const setChangePasswordOrNameRequestState = (
  state,
  { newRequestState },
) => {
  return {
    ...state,
    changePasswordOrNameRequestState: newRequestState,
  }
}
export const setClickedOperatorUser = (state, { rowData }) => {
  let selected
  if (rowData)
    selected = state.operatorUsers.find((user) => user.id === rowData.id)
  return {
    ...state,
    clickedOperatorUser: selected || {},
  }
}
export const setOperatorUserFilter = (state, { filter }) => {
  return {
    ...state,
    operatorUsersFilter: filter,
  }
}

export const resetFilters = (state) => {
  return {
    ...state,
    operatorUsersFilter: [
      ...JSON.parse(JSON.stringify(INITIAL_STATE.operatorUsersFilter)),
    ],
  }
}
export const reducer = createReducer(INITIAL_STATE, {
  [OperatorUserTypes.FETCH_OPERATOR_USER_LIST_LOADING]:
    fetchOperatorUserListLoading,
  [OperatorUserTypes.FETCH_OPERATOR_USER_LIST_SUCCESS]:
    fetchOperatorUserListSuccess,
  [OperatorUserTypes.FETCH_OPERATOR_USER_LIST_FAIL]: fetchOperatorUserListFail,
  [OperatorUserTypes.UPDATE_OPERATOR_USER_LOADING]: updateOperatorUserLoading,
  [OperatorUserTypes.UPDATE_OPERATOR_USER_SUCCESS]: updateOperatorUserSuccess,
  [OperatorUserTypes.UPDATE_OPERATOR_USER_FAIL]: updateOperatorUserFail,
  [OperatorUserTypes.INVITE_OPERATOR_USER_LOADING]: inviteOperatorUserLoading,
  [OperatorUserTypes.INVITE_OPERATOR_USER_SUCCESS]: inviteOperatorUserSuccess,
  [OperatorUserTypes.INVITE_OPERATOR_USER_FAIL]: inviteOperatorUserFail,
  [OperatorUserTypes.FETCH_INVITE_OPERATOR_USER_LIST_LOADING]:
    fetchInviteOperatorUserListLoading,
  [OperatorUserTypes.FETCH_INVITE_OPERATOR_USER_LIST_SUCCESS]:
    fetchInviteOperatorUserListSuccess,
  [OperatorUserTypes.FETCH_INVITE_OPERATOR_USER_LIST_FAIL]:
    fetchInviteOperatorUserListFail,
  [OperatorUserTypes.DELETE_OPERATOR_USER_LOADING]: deleteOperatorUserLoading,
  [OperatorUserTypes.DELETE_OPERATOR_USER_SUCCESS]: deleteOperatorUserSuccess,
  [OperatorUserTypes.DELETE_OPERATOR_USER_FAIL]: deleteOperatorUserFail,
  [OperatorUserTypes.UNBLOCK_OPERATOR_USER_LOADING]: unblockOperatorUserLoading,
  [OperatorUserTypes.UNBLOCK_OPERATOR_USER_SUCCESS]: unblockOperatorUserSuccess,
  [OperatorUserTypes.UNBLOCK_OPERATOR_USER_FAIL]: unblockOperatorUserFail,
  [OperatorUserTypes.DELETE_INVITE_OPERATOR_USER_LOADING]:
    deleteInviteOperatorUserLoading,
  [OperatorUserTypes.DELETE_INVITE_OPERATOR_USER_SUCCESS]:
    deleteInviteOperatorUserSuccess,
  [OperatorUserTypes.DELETE_INVITE_OPERATOR_USER_FAIL]:
    deleteInviteOperatorUserFail,
  [OperatorUserTypes.SEND_OPERATOR_USER_EMAIL_LOADING]:
    sendOperatorUserEmailLoading,
  [OperatorUserTypes.SEND_OPERATOR_USER_EMAIL_SUCCESS]:
    sendOperatorUserEmailSuccess,
  [OperatorUserTypes.SEND_OPERATOR_USER_EMAIL_FAIL]: sendOperatorUserEmailFail,
  [OperatorUserTypes.FETCH_INVITE_OPERATOR_USER_LOADING]:
    fetchInviteOperatorUserLoading,
  [OperatorUserTypes.FETCH_INVITE_OPERATOR_USER_SUCCESS]:
    fetchInviteOperatorUserSuccess,
  [OperatorUserTypes.FETCH_INVITE_OPERATOR_USER_FAIL]:
    fetchInviteOperatorUserFail,
  [OperatorUserTypes.CREATE_OPERATOR_USER_LOADING]: createOperatorUserLoading,
  [OperatorUserTypes.CREATE_OPERATOR_USER_SUCCESS]: createOperatorUserSuccess,
  [OperatorUserTypes.CREATE_OPERATOR_USER_FAIL]: createOperatorUserFail,
  [OperatorUserTypes.SET_INVITE_OPERATOR_USER_STATUS]:
    setInviteOperatorUserStatus,
  [OperatorUserTypes.FETCH_TARIFFS_LIST_LOADING]: fetchTariffsListLoading,
  [OperatorUserTypes.FETCH_TARIFFS_LIST_SUCCESS]: fetchTariffsListSuccess,
  [OperatorUserTypes.FETCH_TARIFFS_LIST_FAIL]: fetchTariffsListFail,
  [OperatorUserTypes.FETCH_PRIVACY_SCHEDULE_LOADING]:
    fetchPrivacyScheduleLoading,
  [OperatorUserTypes.FETCH_PRIVACY_SCHEDULE_SUCCESS]:
    fetchPrivacyScheduleSuccess,
  [OperatorUserTypes.FETCH_PRIVACY_SCHEDULE_FAIL]: fetchPrivacyScheduleFail,
  [OperatorUserTypes.FETCH_ACCESS_GROUPS_LIST_LOADING]:
    fetchAccessGroupsListLoading,
  [OperatorUserTypes.FETCH_ACCESS_GROUPS_LIST_SUCCESS]:
    fetchAccessGroupsListSuccess,
  [OperatorUserTypes.FETCH_ACCESS_GROUPS_LIST_FAIL]: fetchAccessGroupsListFail,
  [OperatorUserTypes.FETCH_INVITE_OPERATOR_USER_LIST_LOADING_MORE]:
    fetchInviteOperatorUserListLoadingMore,
  [OperatorUserTypes.FETCH_OPERATOR_USER_LIST_LOADING_MORE]:
    fetchOperatorUserListLoadingMore,
  [OperatorUserTypes.FETCH_OPERATOR_USERS_COUNT_LOADING]:
    fetchOperatorUsersCountLoading,
  [OperatorUserTypes.FETCH_OPERATOR_USERS_COUNT_SUCCESS]:
    fetchOperatorUsersCountSuccess,
  [OperatorUserTypes.FETCH_OPERATOR_USERS_COUNT_FAIL]:
    fetchOperatorUsersCountFail,
  [OperatorUserTypes.FETCH_OPERATOR_USERS_INVITATIONS_COUNT_LOADING]:
    fetchOperatorUsersInvitationsCountLoading,
  [OperatorUserTypes.FETCH_OPERATOR_USERS_INVITATIONS_COUNT_SUCCESS]:
    fetchOperatorUsersInvitationsCountSuccess,
  [OperatorUserTypes.FETCH_OPERATOR_USERS_INVITATIONS_COUNT_FAIL]:
    fetchOperatorUsersInvitationsCountFail,
  [OperatorUserTypes.CLEAR_OPERATOR_USERS]: clearOperatorUsers,
  [OperatorUserTypes.CLEAR_INVITATIONS]: clearInvitations,
  [OperatorUserTypes.CHANGE_PASSWORD_OR_NAME_LOADING]:
    changePasswordOrNameLoading,
  [OperatorUserTypes.CHANGE_PASSWORD_OR_NAME_SUCCESS]:
    changePasswordOrNameSuccess,
  [OperatorUserTypes.CHANGE_PASSWORD_OR_NAME_FAIL]: changePasswordOrNameFail,
  [OperatorUserTypes.SET_CHANGE_PASSWORD_OR_NAME_REQUEST_STATE]:
    setChangePasswordOrNameRequestState,
  [OperatorUserTypes.SET_CLICKED_OPERATOR_USER]: setClickedOperatorUser,
  [OperatorUserTypes.SET_OPERATOR_USER_FILTER]: setOperatorUserFilter,
  [OperatorUserTypes.RESET_FILTERS]: resetFilters,
})
